import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "profile-user-section" }
const _hoisted_2 = { class: "profile-user-section__primary-info" }
const _hoisted_3 = { class: "profile-user-section__secondary-info" }


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileUserSection',
  props: {
  /** Include secondary info like accountId and fee level */
  withSecondaryInfo: { type: Boolean, require: true },
  /** User email */
  userEmail: { type: String, require: true },
  /** Account holder id */
  accountHolderId: { type: String, require: true },
  /** User name */
  userName: { type: String, require: false },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!
  const _component_x_pid = _resolveComponent("x-pid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ot_icon, {
      class: "profile-user-section__avatar",
      name: "user-square",
      "inherit-stroke": "inherit-stroke"
    }),
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.userName || _ctx.$t('fundamentals.emptyValues.default')), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.userEmail || _ctx.$t('fundamentals.emptyValues.default')), 1),
    (__props.withSecondaryInfo)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (__props.accountHolderId)
            ? (_openBlock(), _createBlock(_component_x_pid, {
                key: 0,
                class: "profile-user-section__secondary-info",
                text: __props.accountHolderId,
                "alt-message": _ctx.$t('fundamentals.copy.message.field', { field: 'ID' })
              }, null, 8, ["text", "alt-message"]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})